var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('cost-card-documents', {
    key: 'cost-card-documents' + _vm.valueCopy.documentId,
    ref: "costCardDocuments",
    staticClass: "mb-3",
    attrs: {
      "disabledDragAndDrop": false,
      "partnerId": _vm.valueCopy.partnerId,
      "clearanceApprovalId": _vm.valueCopy.id,
      "loading": _vm.isConfirmLoading
    },
    on: {
      "created": _vm.onCreatedDocument
    },
    model: {
      value: _vm.documentIds,
      callback: function callback($$v) {
        _vm.documentIds = $$v;
      },
      expression: "documentIds"
    }
  }), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t('clearanceApproval.addResponse.title'),
      "subtitle": _vm.$t('clearanceApproval.addResponse.subtitle'),
      "isDialogActive": _vm.isDialogActive,
      "supressKeyboardActions": true,
      "leftDisabled": _vm.isConfirmLoading,
      "rightLoading": _vm.isConfirmLoading,
      "rightDisabled": !_vm.isValid,
      "rightText": _vm.$t('clearanceApproval.addResponse.confirm')
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "leftClick": _vm.cancel,
      "rightClick": _vm.confirm,
      "close": _vm.cancel
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-row', {
    staticClass: "pt-1",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('v-text-field', {
    ref: "startField",
    attrs: {
      "label": _vm.$t('objects.clearanceApproval.title'),
      "hint": _vm.$t('objects.clearanceApproval.titleHint'),
      "persistent-hint": true,
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.valueCopy.title,
      callback: function callback($$v) {
        _vm.$set(_vm.valueCopy, "title", $$v);
      },
      expression: "valueCopy.title"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "py-4",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("clearanceApproval.addResponse.description")) + " ")])])], 1), _c('line-items-form', {
    attrs: {
      "showQuantity": true
    },
    model: {
      value: _vm.valueCopy,
      callback: function callback($$v) {
        _vm.valueCopy = $$v;
      },
      expression: "valueCopy"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }